<div class="success-overlay" [@popIn]>
    <div class="success-card">
      <img
        src="assets/personalView/pulsecheck_submissionSuccess.svg"
        alt="Success"
        class="success-image"
        [ngClass]="{'is-mobile-view': isMobileView}"
      />
      <h2>{{'pulseCheckView.submissionSuccess.header' | translate}}</h2>
      <p class="success-message">{{'pulseCheckView.submissionSuccess.message' | translate : {frequency_text: frequencyText} }}</p>
      <br>
      <p class="success-message">{{'pulseCheckView.submissionSuccess.closePage' | translate}}</p>
    </div>
  
    <!-- CSS confetti pieces -->
    <div
      *ngFor="let c of confettis"
      class="confetti-piece"
      [ngStyle]="c.style"
    ></div>
  </div>
  